import { borderRadius, breakpoints, fonts, fontWeight, shadow, spacing, typography } from "./build";
var determineBorderRadiusValue = function (value) {
    if (value === "0") {
        return value;
    }
    return borderRadius[value || "md"];
};
var determineSpacingValue = function (value) {
    if (value === "0" || value === "auto") {
        return value;
    }
    else if (value === null || value === void 0 ? void 0 : value.startsWith("-")) {
        return "-".concat(spacing["space".concat(value.replace("-", ""))]);
    }
    return spacing["space".concat(value || "Base")];
};
export var breakpointKeys = ["sm", "md", "lg", "xl", "xxl"];
export var tokens = {
    borderRadius: function (size) {
        return typeof size === "object"
            ? size.map(function (value) { return determineBorderRadiusValue(value); }).join(" ")
            : determineBorderRadiusValue(size);
    },
    breakpoint: function (size) { return breakpoints[size]; },
    font: function (type) { return "".concat(fonts[type], ", sans-serif"); },
    fontWeight: function (weight) { return fontWeight[weight]; },
    shadow: function (size) { return shadow[size || "base"]; },
    spacing: function (size) {
        if (typeof size === "object") {
            return size.map(function (value) { return determineSpacingValue(value); }).join(" ");
        }
        return determineSpacingValue(size);
    },
    text: function (size) { return typography["text".concat(size || "base")]; },
};
//# sourceMappingURL=tokens.js.map